/**
 * Directive: timePicker
 */
angular.module('acme.common.directive.timePicker', [])
.directive('timePicker', [function() {

    return {
      restrict: 'A',
      replace: true,
      templateUrl: 'common/directives/timePicker/timePicker.tpl.html',
      scope: {
        hour: '=',
        minute: '=',
        ampm: '=',
        typeLabel: '@typelabel',
        timePickerIndex: '@timepickerindex'
      },
      
      link: function($scope, $element, $attrs) {
        // Modified after controller runs
      },

      controller: ['$scope', function($scope) {

        $scope.timePicker = {

          minutes: [],
          hours: [],
          ampm: ['am', 'pm'],

          init: function() {
            this.minutes = this.getMinutes();
            this.hours = this.getHours();
            console.log('timePicker::init', this.hours, this.minutes);
          },

          getHours: function() {
            var i,
              hours = [];

            for (i=1;i<=12;i++) {
              hours.push(i);
            }

            return hours;
          },

          getMinutes: function() {
            var i,
              min = "",
              minutes = [];

            for (i=0;i<60;i+=5) {
              min = (i<10) ? "0" + i : i;

              minutes.push(min);
            }

            return minutes;
          },

          setInputFocus: function(index, fieldId) {
            var el = $('#' + fieldId + '-' + (index || 0));
            if (el.length && el.find('input').length) {
              el.find('input').get(0).focus();
            }
          }
        };

        $scope.timePicker.init();

      }]

    };

}]);